var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingLeadership(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56.26mm",
    height: "53.591mm",
    viewBox: "0 0 56.26 53.591",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.71 153.31h159.48v151.91h-159.48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath294"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.71 153.31h159.48v151.91h-159.48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m557 174h149v57h-149z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath304"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m557.55 174.4h112.45v55.802h-112.45z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath324"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.71 153.31h159.48v151.91h-159.48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m548 153h149v57h-149z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath334"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m548.46 153.31h121.54v55.803h-121.54z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-69.02 -79.853)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -110.79 187.53)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m601.67 219.01c-0.1614-0.0931-0.3222-0.1863-0.4836-0.2794 0.1614 0.0931 0.3222 0.1863 0.4836 0.2794",
    fill: "#b22e4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m657.54 192.76c0-15.41-33.093-27.901-73.916-27.901-40.822 0-73.916 12.492-73.916 27.901 0 15.41 33.094 27.901 73.916 27.901 40.823 0 73.916-12.492 73.916-27.901",
    fill: "#175583"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath294)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath300)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m705.38 202.3c0-15.41-33.093-27.901-73.916-27.901-40.822 0-73.916 12.492-73.916 27.901s33.094 27.901 73.916 27.901c40.823 0 73.916-12.492 73.916-27.901",
    fill: "#70bde5"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath324)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath330)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m696.29 181.22c0-15.41-33.093-27.901-73.916-27.901-40.822 0-73.916 12.492-73.916 27.901 0 15.41 33.094 27.901 73.916 27.901 40.823 0 73.916-12.492 73.916-27.901",
    fill: "#1e6eac"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m642.18 291.34c-6.1199 0-11.098-4.9785-11.098-11.098s4.9785-11.098 11.098-11.098c6.1193 0 11.098 4.9785 11.098 11.098s-4.9785 11.098-11.098 11.098",
    fill: "#a1c74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.18 269.15c-6.1199 0-11.098 4.9785-11.098 11.098s4.9785 11.098 11.098 11.098c6.1193 0 11.098-4.9785 11.098-11.098s-4.9785-11.098-11.098-11.098",
    fill: "#a1c74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.34 290.23c-6.1193 0-11.098-4.9785-11.098-11.098s4.9785-11.098 11.098-11.098 11.098 4.9785 11.098 11.098-4.9785 11.098-11.098 11.098",
    fill: "#70bde5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.34 268.03c-6.1193 0-11.098 4.9785-11.098 11.098 0 6.1193 4.9785 11.098 11.098 11.098s11.098-4.9785 11.098-11.098c0-6.1192-4.9785-11.098-11.098-11.098",
    fill: "#70bde5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m656.6 255.92c-3.5723 6.4599-11.162 9.7866-18.329 8.0154-2.5827-0.6386-4.8477-1.8349-6.7197-3.4153 0.2967-0.6463 0.5647-1.3092 0.8007-1.9887 0.906-2.6032 1.3061-5.3288 1.1906-8.1004l-0.1493-1.7207c-0.2048-1.077-3.0421-11.266-4.1031-15.062 3.1569-10.508 7.8898-26.206 10.761-35.723 0.7318-2.4258 4.172-2.4066 4.8758 0.0281 4.431 15.329 13.485 46.76 13.64 48.192l8e-3 0.0287h-5e-3c0.342 3.2086-0.2195 6.5819-1.9696 9.7465",
    fill: "#a1c74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m590.16 246.02c-0.0702 0.2686-0.1206 0.4606-0.1512 0.5697l-0.0217 0.0989-0.3841 2.4367c-0.3025 3.051 0.0293 6.0318 0.8951 8.8034-3.9959 4.3532-10.175 6.3541-16.074 4.8962-8.6286-2.1323-13.735-10.452-12.348-18.733l-0.081-2e-3 0.2111-0.7031c0.1079-0.506 9.4198-31.397 13.998-46.572 0.7319-2.4264 4.1721-2.4067 4.8758 0.0274 3.1372 10.853 8.5904 29.773 11.564 40.409-1.2965 4.248-2.133 7.4349-2.4832 8.769",
    fill: "#70bde5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631.29 249.21h-6e-3c0.3573 3.3541-0.1046 6.8575-1.609 10.217-4.033 9.0018-14.277 13.741-23.74 10.954-9.8651-2.9049-15.627-12.646-14.004-22.342l-0.0976-3e-3 0.2552-0.8466c0.134-0.6298 12.083-40.262 17.383-57.831 0.7319-2.4258 4.1714-2.4067 4.8752 0.0274 5.1297 17.736 16.74 58.008 16.933 59.789l0.01 0.0344z",
    fill: "#175583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.15 290.28c0-8.2573-6.6935-14.951-14.951-14.951-8.2567 0-14.951 6.6935-14.951 14.951s6.6941 14.951 14.951 14.951c8.2573 0 14.951-6.6935 14.951-14.951",
    fill: "#175583"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingLeadership);
export default __webpack_public_path__ + "static/media/landing_leadership.977730c6964552b759cbba0dafce7ea7.svg";
export { ForwardRef as ReactComponent };